import React from "react";
import { CalendarToday, Check, CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { Button, IconButton, ListItemIcon, Menu, MenuItem, Paper, Toolbar, Typography } from "@mui/material";
const tipos = [
    {nome: 'Diário', type:'diario'},
    {nome: 'Semanal', type:'semanal'},
    {nome: 'Mensal', type:'mensal'},
    // {nome: 'Anual', type:'anual'},
]
export default function CalendarioViewMenu(props) {
    const { type, setType } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleEscolhe(e){        
        setType(e.type);
        handleClose();
    }

    return (
        <React.Fragment>
            <IconButton
                color="primary" aria-label="Tipos de visão"
                onClick={handleClick}
            >
                <CalendarToday />
            </IconButton>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {tipos.map((row, id) =>(
                    <MenuItem key={id} onClick={() => handleEscolhe(row)} name={row.type}>
                    { type === row.type && <ListItemIcon>
                        <CheckBox />
                    </ListItemIcon>}
                    { type !== row.type && <ListItemIcon>
                        <CheckBoxOutlineBlank />
                    </ListItemIcon>}
                    {row.nome}
                </MenuItem>
                ))}                
                
            </Menu>
        </React.Fragment>
    )
}